'use strict';

/* jshint -W098 */
angular.module('mean.bids').controller('BidBuilderController', ['$scope', 'Global', 'MeanUser', 'Bids', 'Builders', '$filter', '$sce', 'toaster', 'NotifyService', 'BidBuilderReview', '$http', 'CompanyFactors', '$location',
  function($scope, Global, MeanUser, Bids, Builders, $filter, $sce, toaster, NotifyService, BidBuilderReview, $http, CompanyFactors, $location) {
    $scope.global = Global;
    $scope.package = {
      name: 'bids'
    };

    $scope.mean_user = MeanUser;
    $scope.my_divisions = [];
    $scope.my_review_bids = [];

    $scope.pop = function() {
    	toaster.pop('success', 'title', 'text');
    };

    $scope.init = function() {
    	$scope.editId = 1;

        $scope.mean_user = MeanUser;

        //get the builder names and divisions that i'm associated with
        Builders.query({}, function(builders) {
            builders.forEach(function(builder, idx) {
                builder.division.forEach(function(div) {
                    div.builders.forEach(function(build) {
                        if(build === MeanUser.user._id) {
                            $scope.my_divisions.push({
                                builder_name: builder.name,
                                division_name: div.name
                            });
                        }
                    });
                });
            });
        });

        Bids.query({}, function(bids) {
            //create a list of review bids based on my builder/division info
            $scope.my_divisions.forEach(function(div) {
                bids.forEach(function(bid, idx) {
                    if(bid.builder_name === div.builder_name &&
                        bid.builder_division === div.division_name &&
                        bid.bid_status === 'builder_review')
                          $scope.my_review_bids.push(bid);
                });
            });
	    });
    };
    
    $scope.viewBidBuilderDetails = function(index) {
        BidBuilderReview.set($scope.my_review_bids[index]);
        $location.path('builder/details');
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/bids/public/controllers/bidbuilder.js